import { Component, OnInit, inject } from "@angular/core";
import { slideFromUp, zoomInOut } from "../../core-ui.animations";
import { ConferenceService } from "../../services";

@Component({
  selector: "app-stream-play-button",
  templateUrl: "./stream-play-button.component.html",
  styleUrls: ["./stream-play-button.component.scss"],
  animations: [slideFromUp, zoomInOut],
  standalone: false,
})
export class StreamPlayButtonComponent implements OnInit {
  private conferenceService = inject(ConferenceService);

  visible: boolean;

  ngOnInit() {
    this.conferenceService.streamsNeedToPlay$.subscribe((play) => {
      this.visible = play;
    });
  }

  play() {
    this.visible = false;
    this.conferenceService.playPausedStreams();
  }
}
